import React, { useEffect, useState } from 'react'
import { Form, Input, InputOnChangeData } from 'semantic-ui-react'
import { useAccountSearch } from '../../hooks'
import { useFormatMessage } from '../../utils'
import styles from './styles.module.less'

const MIN_SEARCH_LENGTH = 3

const AccountSearchBar = () => {
  const {
    accountSearchState: { loadingResults, searchTerm = '' },
    searchAccounts,
  } = useAccountSearch()
  const formatMessage = useFormatMessage()
  const [search, setSearch] = useState(searchTerm)

  useEffect(() => {
    if (searchTerm.length === 0) {
      setSearch('')
    }
  }, [searchTerm])

  const handleSubmit = () => searchAccounts(search)

  return (
    <Form className={styles.accountSearchBar} onSubmit={handleSubmit}>
      <Form.Group className={styles.searchBarFields}>
        <Form.Field width={5}>
          <label>{formatMessage('accounts.search.label')}</label>
          <Input
            className="test-id-search-input"
            icon="search"
            placeholder={formatMessage('accounts.search.placeholder')}
            value={search}
            aria-label="search"
            onChange={(_, data: InputOnChangeData) => {
              setSearch(data.value)
            }}
            required={true}
          />
        </Form.Field>
        <Form.Button
          className={styles.searchBtnField}
          type="submit"
          disabled={search.length < MIN_SEARCH_LENGTH}
          loading={loadingResults}
        >
          {formatMessage('accounts.search')}
        </Form.Button>
      </Form.Group>
    </Form>
  )
}

export default AccountSearchBar
